<template>
    <div>
        <loading v-if="loading && loading !== -1" />
        <div
            data-search-bar
            class="topBar stickySearchBox">
            <div class="responsiveSection__grid gridBox search__grid search__gridSearchBarRow">
                <SearchBar :key="searchKey" />
            </div>
        </div>
        <div ref="scrollTrigger"></div>
        <Sidebar
            v-if="showSidebar"
            @closeSidebar="updateShowSidebar(false)" />
        <!-- headline for search page included results number and sort filter -->
        <template>
            <!-- new component for top headline (new Mockup design) -->
            <SearchHeadline />
        </template>
        <!-- Content area -->
        <section class="responsiveSection">
            <div class="responsiveSection__grid gridBox">
                <div class="search__grid">
                    <div
                        v-if="hasResults"
                        class="resultList search__gridResultList">
                        <!-- Editorial pick -->
                        <template v-if="hasPromoted">
                            <template>
                                <div
                                    v-for="(item, index) in promotedArray"
                                    :key="item.uid"
                                    class="resultList__itemWrapper hideOnMobile--block">
                                    <show-item
                                        :item="item"
                                        :promoted="true"
                                        :index="index" />
                                </div>
                            </template>
                            <template>
                                <div class="hideOnDesktop itemContent__editorialWrapper--mobile">
                                    <div
                                        v-for="(item, index) in promotedArray"
                                        :key="item.uid"
                                        class="resultList__itemWrapper">
                                        <span class="itemContent__editorial">
                                            {{ trans('EDITORIAL_PICK') }}
                                        </span>
                                        <show-item
                                            :item="item"
                                            :promoted="true"
                                            :index="index" />
                                        <div
                                            v-if="index === 1"
                                            class="facetedSearch__backgroundWrapper">
                                            <FacetedSearchMobile />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <!-- Content -->
                        <div
                            v-for="(item, index) in resultArray"
                            :key="index"
                            class="resultList__itemWrapper"
                            data-results
                            :data-gtm-contenttype="entityName(item.identity)">
                            <tooltip
                                v-if="entityName(item.identity) === ent.STATISTIC && !isMobile"
                                :settings="{ position: 'top', width: 600 }">
                                <show-item
                                    :item="item"
                                    :index="index + promotedArray.length" />
                                <template #content>
                                    <div class="aoTable__tooltip">
                                        <img
                                            :src="getThumbnail(item)"
                                            class="aoTable__tooltipImg"
                                            aria-hidden="true"
                                            height="71"
                                            width="100"
                                            alt="" />
                                        <div class="aoTable__tooltipContent">
                                            <div class="aoTable__tooltipContentTop">
                                                {{ getTitle(item) }}
                                            </div>
                                            <div class="aoTable__tooltipContentBottom">
                                                {{ getContent(item) }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </tooltip>
                            <show-item
                                v-else
                                :item="item"
                                :index="index + promotedArray.length" />
                            <div
                                v-if="index === 1 && promotedArray.length < 2"
                                class="hideOnDesktop--block facetedSearch__backgroundWrapper">
                                <FacetedSearchMobile />
                            </div>
                        </div>

                        <!-- PAGINATOR -->
                        <div
                            id="searchPaginator"
                            class="row center">
                            <div class="display-inline-block display-s-block">
                                <div class="pagination paginationRound searchPagination">
                                    <ul class="paginationRound__list">
                                        <li class="pagination__item--back paginationRound__circle--border">
                                            <button
                                                type="button"
                                                :class="{ 'paginationRound__circlePrev': true, 'paginationRound__circlePrev--disabled': currentPage === 1 }"
                                                rel="prev"
                                                :data-gtm="`pagination__previous--${ currentPage - 1 }`"
                                                :aria-label="trans('PREVIOUS_PAGE')"
                                                @click="setPage(-1)">
                                                <svg
                                                    aria-hidden="true"
                                                    height="13"
                                                    width="13">
                                                    <use href="#iconChevronLeftBold" />
                                                </svg>
                                            </button>
                                        </li>

                                        <li class="text-bold margin-right-10 margin-left-20">
                                            {{ currentPage }}
                                        </li>
                                        <li class="margin-right-10">
                                            &frasl;
                                        </li>
                                        <li class="margin-right-20">
                                            {{ totalPages }}
                                        </li>

                                        <li class="pagination__item--next paginationRound__circle--border">
                                            <button
                                                type="button"
                                                :class="{ 'paginationRound__circleNext': true, 'paginationRound__circleNext--disabled': currentPage === totalPages }"
                                                rel="next"
                                                :data-gtm="`pagination__next--${ currentPage + 1 }`"
                                                :aria-label="trans('NEXT_PAGE')"
                                                @click="setPage(+1)">
                                                <svg
                                                    aria-hidden="true"
                                                    height="13"
                                                    width="13">
                                                    <use href="#iconChevronRightBold" />
                                                </svg>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- No results -->
                    <div
                        v-else-if="!loading && loading !== -1 && !isArchive"
                        class="noResultBox">
                        {{ archive }}
                        <div class="newAlert info">
                            <b>{{ trans('SEARCH_NO_RESULTS_TITLE') }}</b>
                            <div v-if="Number(language) !== 0">
                                <span>
                                    {{ trans('TEXT_FOR_SEARCH_ONLY_PLATFORM_LANGUAGE') }}
                                    <button
                                        class="noResultBox__link"
                                        type="button"
                                        @click="enableAllLanguages()">{{ trans('LINK_TEST_FOR_ALL_LANGUAGE_SEARCH') }}</button>
                                    {{ trans('SEARCH_NO_RESULTS_TEXT_ARCHIVE') }}
                                </span>
                            </div>
                            <div v-else>
                                <p>
                                    {{ trans('SEARCH_NO_RESULTS_TEXT_ARCHIVE_WITHOUT_LANGUAGE_FILTER') }}
                                </p>
                            </div>
                            <br />
                            <div class="center">
                                <button
                                    class="button"
                                    @click="addArchive">
                                    {{ trans('SEARCH_ARCHIVE_BUTTON') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!loading && loading !== -1 && isArchive">
                        <div class="newAlert info">
                            <b>{{ trans('FORM_SEARCH_NO_RESULTS') }}</b>
                        </div>
                    </div>
                    <!-- Filters, regional boost, facetted search & interessting topics and facts "change FE" fror oggedin users-->
                    <template>
                        <!-- new component for right column (new Mockup design) -->
                        <RightColumn :key="rerenderTriggerKey" />
                    </template>
                    <!-- PROMO BANNER HERE-->
                </div>
            </div>
        </section>
        <Banner
            v-if="Number(idBasic) === 1 && Number(idStandard) === 0"
            :corporate="false" />
    </div>
</template>

<script>
    import { ref, computed } from 'vue';
    import { useActions, useGetters } from 'composables/useVuex';
    import Translator from 'tools/trans';
    import { isMobile } from 'tools/isMobile';
    import { getStudyCoverUrl, setStudyCoverSrcset, setResponsiveSizes, getFiveThousandBlock } from 'tools/getStudyCover';
    import { numberFormat } from 'tools/numberFormat';
    import Tooltip from 'components/tooltip';
    import Loading from './loading.vue';
    import SearchBar from './searchBar';
    import ShowItem from './showItem.vue';
    import Banner from './components/banner';
    import { defaultLanguageValue, ent, pathExt } from './store/search.module';
    import RightColumn from './rightColumn';
    import Sidebar from './sidebar';
    import SearchHeadline from './searchHeadline';
    import FacetedSearchMobile from './components/facetedSearchMobile';
    import { pushToDataLayer } from './dataLayer';

    // don't delete this line -> it's necessary to get this translation inside via webpack
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Translator.trans('FORM_SEARCH_OFF');
    const IdRelevance = 'idrelevance';
    const GCS = 'gcs';
    const GCSREPORT = 'gcsReports';
    export default {
        name: 'SearchContent',
        components: {
            Loading,
            Tooltip,
            ShowItem,
            Banner,
            Sidebar,
            RightColumn,
            SearchHeadline,
            FacetedSearchMobile,
            SearchBar,
        },
        props: {
            idBasic: { type: String, default: '0' },
            idStandard: { type: String, default: '0' },
        },
        data() {
            return {
                isMobile: isMobile(),
                showDropdown: !isMobile(),
                windowSize: ref(window.innerWidth),
                hideFocusFilter: false,
                rerenderTriggerKey: Date.now(),
            };
        },

        computed: {
            /* eslint-disable vue/return-in-computed-property */
            isArchive() {
                if (this.archive === 0) {
                    return true;
                } else if (this.archive === null) {
                    return false;
                }
            },
            /* eslint-enable */
            hasPromoted() {
                return this.promotedArray && this.promotedArray.length > 0;
            },
            hasResults() {
                return this.resultArray && this.resultArray.length > 0;
            },
            localeEnDe() {
                return window.stGlobals.locale === 'de' ? 'de' : 'en';
            },
        },
        watch: {
            windowSize() {
                this.isMobile = isMobile();
                this.showDropdown = !isMobile();
            },
            loading() {
                this.rerenderTriggerKey = Date.now();
            },
        },
        methods: {
            trans: Translator.trans,
            tagBeautify(tag) {
                return tag.slice(0, 25) + (tag.length > 25 ? '...' : '');
            },
            changeFocus() {
                const resultList = document.querySelector('[data-results]');
                resultList.firstElementChild.focus();
            },
            async enableAllLanguages() {
                await this.setLanguage();
                this.rerenderTriggerKey = Date.now();
            },
            scrollSearchbar() {
                const options = { rootMargin: '-80px 0px 0px 0px' };
                const observer = new IntersectionObserver(
                    ([event]) => {
                        if (event.isIntersecting) {
                            document.querySelector('[data-search-bar]').classList.remove('topBar__shadow', 'topBar--zIndex--3000');
                        } else {
                            document.querySelector('[data-search-bar]').classList.add('topBar__shadow', 'topBar--zIndex--3000');
                        }
                    }, options,
                );
                observer.observe(this.$refs.scrollTrigger);
            },
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowSize = window.innerWidth;
            });
            this.updateFilteredNumber();
            this.hideFocusFilter = this.sortOption !== IdRelevance;
            this.scrollSearchbar();
            document.addEventListener('DOMContentLoaded', function() {
                let lastScrollTop = 0;

                window.addEventListener('scroll', function() {
                    const currentScrollTop = window.scrollY;
                    const element = document.querySelector('[data-search-bar]');
                    // Check scroll direction
                    if (currentScrollTop > lastScrollTop) {
                        // Scrolling down
                        if (element) {
                            element.classList.remove('stickySearchBox--hide');
                        }
                    }
                    if (currentScrollTop <= lastScrollTop) {
                        // Scrolling up
                        if (element) {
                            element.classList.add('stickySearchBox--hide');
                        }
                    }

                    lastScrollTop = currentScrollTop;
                    if (currentScrollTop === 0) {
                        if (element) {
                            element.classList.remove('stickySearchBox--hide');
                        }
                    }
                });
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', () => {
                this.windowSize = window.innerWidth;
            });
        },
        setup() {
            const searchKey = ref(0);
            const sidebarKey = ref(0);
            window.onpopstate = function() {
                resetPage();
            };
            const sortOptions = [
                { value: 'idrelevance', name: Translator.trans('FORM_SEARCH_RELEVANCE') },
                { value: 'publicationDate', name: Translator.trans('FORM_SEARCH_DATE') },
            // { value: 'popularity', name: trans('FORM_SEARCH_POPULARITY') },
            ];

            const filterNumbers = ref(0);

            const searchForm = ref(null),
                  sortOption = computed(() => {
                      return getters.sort.value || 'idrelevance';
                  }),
                  filterOption = computed(() => {
                      return getters.focus.value || '-1';
                  }),
                  filterOptions = computed(() => {
                      return getters.countries.value.map(item => {
                          return {
                              value: item.value,
                              name: Translator.trans(item.label),
                          };
                      });
                  });

            const getters = {
                ...useGetters('search', [
                    'query',
                    'resultCount',
                    'resultArray',
                    'masterTags',
                    'promotedArray',
                    'repoArray',
                    'entity',
                    'entityName',
                    'getTitle',
                    'getContent',
                    'currentPage',
                    'totalPages',
                    'loading',
                    'topic',
                    'topics',
                    'countries',
                    'path',
                    'sort',
                    'focus',
                    'location',
                    'archive',
                    'tags',
                    'getShowSidebar',
                    'tagsOptions',
                    'language',
                    'userPermissionToGCS',
                ]),
            };
            const showSidebar = getters.getShowSidebar;
            const actions = {
                ...useActions('search', [
                    'resetPageNumber',
                    'getPage',
                    'updateData',
                    'updateLoaderStatus',
                    'setSort',
                    'setFocus',
                    'setLocation',
                    'setValue',
                    'setArchive',
                    'setTags',
                    'unsetTags',
                    'resetAllTags',
                    'getReports',
                    'getTopic',
                    'updateShowSidebar',
                    'setLanguage',
                ]),
            };

            function getCount() {
                let count = getters.resultCount.value();
                if (name === GCS) {
                    if (window.stGlobals.user && this.userPermissionToGCS) {
                        count = count + this.getOriginalMetric(GCSREPORT);
                    } else {
                        count = this.getOriginalMetric(GCSREPORT);
                    }
                }
                if (count > 1000) {
                    return `>&nbsp;${ numberFormat(1000) }`;
                }
                if (isNaN(count)) {
                    return 0;
                }

                return Number(count);
            }

            async function selectSort(option) {
                await actions.resetPageNumber();
                actions.setSort(option);
            }

            async function selectFilter(option) {
                await actions.resetPageNumber();
                actions.setFocus(option);
            }
            async function selectLocation(option) {
                await actions.resetPageNumber();
                actions.setLocation(option);
            }
            async function addArchive() {
                await actions.setArchive();
            }
            async function updateFilteredNumber() {
                const queryString = window.location.search;
                const uparams = new URLSearchParams(queryString);

                let number = 0;
                if (uparams && uparams.get('interval') && uparams.get('interval') !== '0') {
                    number = number + 1;
                }
                if (uparams && uparams.get('tabGroup')) {
                    number = number + uparams.get('tabGroup').split(',').length;
                }
                if (uparams && uparams.get('accuracy') && uparams.get('accuracy') !== 'and') {
                    number = number + 1;
                }
                if (uparams && uparams.get('isoregion')) {
                    if (uparams.get('isoregion') !== '0') {
                        number = number + 1;
                    } else if (uparams.get('region[]') && uparams.get('region[]') !== '') {
                        number = number + 1;
                    }
                } else if (uparams.get('region[]') && uparams.get('region[]') !== []) { // this will always return true, please fix! (comment by Rolf)
                    number = number + 1;
                }
                if (uparams && uparams.get('idRelevance') && uparams.get('idRelevance') !== '0') {
                    number = number + 1;
                }
                if (uparams && uparams.get('category[]') && uparams.get('category[]') !== '0') {
                    number = number + 1;
                }
                if (uparams && uparams.get('language') && uparams.get('language') !== defaultLanguageValue[window.stGlobals.locale]) {
                    number = number + 1;
                }

                filterNumbers.value = number;
            }
            async function updateShowSidebar(value) {
                if (value) {
                    document.querySelector('body').addEventListener('click', function(e) {
                        const anchor = e.target.closest('header');
                        if (anchor !== null) {
                            actions.updateShowSidebar(false);
                        }
                    }, false);
                } else {
                    document.querySelector('body').removeEventListener('click', function(e) {
                        const anchor = e.target.closest('header');
                        if (anchor !== null) {
                            actions.updateShowSidebar(false);
                        }
                    }, false);
                }
                await actions.updateShowSidebar(value);
                await updateFilteredNumber();
                sidebarKey.value = sidebarKey.value + 1;
                if (value) {
                    document.getElementById('sidebar__main').tabIndex = '0';
                    document.getElementById('sidebar__main').focus();
                }
            }
            async function setPage(num) {
                // check if it's allowed
                if (getters.currentPage.value === 1 && num === -1) {
                    return;
                }
                if (getters.currentPage.value === getters.totalPages.value && num === +1) {
                    return;
                }
                if (getters.currentPage.value > getters.totalPages.value) {
                    return;
                }
                await actions.updateLoaderStatus(true);
                await actions.getPage({ num: num, tags: getters.tags.value.length > 0 });
                await actions.updateLoaderStatus(false);
                // update topics when page changed (right side of search page)
                await actions.getTopic();
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE

                setTimeout(() => {
                    pushToDataLayer();
                }, 100);
            }
            async function resetPage() {
                await actions.updateData();

                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE */
                searchKey.value = searchKey.value + 1;
            }
            function openLink(item) {
                return getters.path.value(item);
            }
            function getThumbnail(statistic) {
                if (statistic.displaytype === '4') {
                    // Always the same image for tables
                    return 'https://cdn.statcdn.com/Statistic/table/table-100-1.png';
                } else {
                    return `https://cdn.statcdn.com/Statistic/${ getFiveThousandBlock(statistic.idcontent) }/${ statistic.idcontent }-blank-100.png`;
                }
            }
            async function setLanguage() {
                await actions.setLanguage(0);
            }

            return {
                showSidebar,
                getStudyCoverUrl,
                setStudyCoverSrcset,
                setResponsiveSizes,
                getThumbnail,
                searchForm,
                getCount,
                sortOptions,
                sortOption,
                filterOption,
                selectSort,
                filterOptions,
                selectFilter,
                selectLocation,
                addArchive,
                openLink,
                setPage,
                updateShowSidebar,
                filterNumbers,
                updateFilteredNumber,
                numberFormat,
                resetPage,
                setLanguage,
                defaultLanguageValue,
                ent,
                pathExt,
                searchKey,
                sidebarKey,
                ...getters,
            };
        },
    };
</script>
